import React from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f0f2f5',
      padding: 32,
      fontFamily: '"Inter", "Roboto", "Segoe UI", sans-serif',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        {/* Шапка */}
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          marginBottom: 40,
        }}>
          <div>
            <h1 style={{ margin: 0, fontSize: 28, fontWeight: 700, color: '#1a1a1a' }}>MAX Bot Manager</h1>
            <p style={{ margin: '4px 0 0', color: '#666', fontSize: 14 }}>Панель управления чат‑ботом</p>
          </div>
          <button
            onClick={handleLogout}
            style={{
              padding: '10px 20px',
              background: 'white',
              border: '1px solid #e0e0e0',
              borderRadius: 8,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 500,
              color: '#555',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            }}
          >
            Выйти
          </button>
        </div>

        {/* Карточки быстрого доступа */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 24,
          marginBottom: 32,
        }}>
          <Card
            icon="🎭"
            title="Сценарии"
            desc="Визуальный конструктор меню и кнопок"
            onClick={() => navigate('/scenarios')}
          />
          <Card
            icon="📢"
            title="Рассылки"
            desc="Создание и запуск массовых сообщений"
            onClick={() => navigate('/broadcasts')}
          />
          <Card
            icon="💬"
            title="Live‑чат"
            desc="Общение с пользователями в реальном времени"
            onClick={() => navigate('/livechat')}
          />
          <Card
            icon="⚙️"
            title="Настройки"
            desc="Управление ботом, оператором и пользователями"
            onClick={() => navigate('/settings')}
          />
        </div>

        {/* Инфо-блок (можно позже заменить на статистику) */}
        <div style={{
          background: 'white',
          borderRadius: 12,
          padding: 24,
          boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
        }}>
          <h3 style={{ margin: '0 0 16px', fontWeight: 600, fontSize: 18 }}>Добро пожаловать!</h3>
          <p style={{ margin: 0, color: '#555', lineHeight: 1.6 }}>
            Здесь вы можете управлять диалогами, создавать сценарии, запускать рассылки и отвечать пользователям.
            Выберите нужный раздел выше, чтобы начать работу.
          </p>
        </div>
      </div>
    </div>
  );
};

/* Вспомогательный компонент карточки */
const Card: React.FC<{
  icon: string;
  title: string;
  desc: string;
  onClick: () => void;
}> = ({ icon, title, desc, onClick }) => (
  <div
    onClick={onClick}
    style={{
      background: 'white',
      borderRadius: 12,
      padding: 24,
      cursor: 'pointer',
      boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
      border: '1px solid #f0f0f0',
      transition: 'transform 0.15s, box-shadow 0.15s',
      userSelect: 'none',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.08)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.04)';
    }}
  >
    <div style={{ fontSize: 32, marginBottom: 12 }}>{icon}</div>
    <h3 style={{ margin: '0 0 4px', fontSize: 16, fontWeight: 600 }}>{title}</h3>
    <p style={{ margin: 0, fontSize: 13, color: '#777' }}>{desc}</p>
  </div>
);

export default Dashboard;